import type { DeepString } from "@/lib/i18n";

export const pl = {
  readMore: "Czytaj więcej",
  showAll: "Pokaż wszystkie",
} as const;

export type WLatestBlogPostsTranslations = DeepString<typeof pl>;
